import { IErrorResponse } from "../../interfaces/extract.interface";
import { IPresetTyped } from "../../interfaces/presets.interface";

const ActionTypes = {
    RENAME_PRESET: '[Preset] Rename Preset',
    RENAME_PRESET_SUCCESS: '[Preset] Rename Preset Success',
    RENAME_PRESET_FAIL: '[Preset] Rename Preset Fail',
    
    REMOVE_PRESET: '[Preset] Remove Preset',
    REMOVE_PRESET_SUCCESS: '[Preset] Remove Preset Success',
    REMOVE_PRESET_FAIL: '[Preset] Remove Preset Fail'
}

export class RenamePreset {
  static type = ActionTypes.RENAME_PRESET;

  constructor(public payload: {
    oldName: string,
    newName: string,
    presetType: string
  }) {}
}

export class RenamePresetSuccess {
  static type = ActionTypes.RENAME_PRESET_SUCCESS;

  constructor(public payload: IPresetTyped) {}
}

export class RenamePresetFail {
  static type = ActionTypes.RENAME_PRESET_FAIL;

  constructor (public payload: IErrorResponse) {}
}

export class RemovePreset {
  static type = ActionTypes.REMOVE_PRESET;

  constructor(public payload: IPresetTyped) {}
}

export class RemovePresetSuccess {
  static type = ActionTypes.REMOVE_PRESET_SUCCESS;

  constructor(public payload: IPresetTyped) {}
}

export class RemovePresetFail {
  static type = ActionTypes.REMOVE_PRESET_FAIL;

  constructor (public payload: IErrorResponse) {}
}